import React from "react";
import { useNavigate } from "react-router-dom";
import { Container, Spinner } from "react-bootstrap";
import { useLeague } from "../hooks/useLeague";
import "./MyLeaguesPage.css";

export default function MyLeaguesPage() {
  const navigate = useNavigate();
  const { leagues, setCurrentLeague, isLoading } = useLeague();

  const handleLeagueClick = (league: any) => {
    setCurrentLeague(league);
    navigate(`/leagues/${league.abbr}`);
  };

  return (
    <Container className="my-leagues-page">
      <div className="my-leagues-header">
        <h1 className="my-leagues-title">My Leagues</h1>
        <p className="my-leagues-subtitle">
          Select a league to view standings, schedules, and stats
        </p>
      </div>

      {isLoading ? (
        <div className="my-leagues-loading">
          <Spinner animation="border" variant="primary" />
          <p className="mt-3 text-muted">Loading your leagues...</p>
        </div>
      ) : leagues.length === 0 ? (
        <div className="my-leagues-empty">
          <div className="my-leagues-empty-icon">
            <i className="bi bi-trophy" />
          </div>
          <h2 className="my-leagues-empty-title">No leagues yet</h2>
          <p className="my-leagues-empty-text">
            Create your first league to get started with Podium.
          </p>
        </div>
      ) : (
        <div className="my-leagues-list">
          {leagues.map((league) => (
            <div
              key={league.id}
              className="my-leagues-card"
              onClick={() => handleLeagueClick(league)}
              role="button"
              tabIndex={0}
              onKeyPress={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  handleLeagueClick(league);
                }
              }}
            >
              <div className="my-leagues-card-content">
                <div className="my-leagues-card-icon">
                  <i className="bi bi-trophy-fill" />
                </div>
                <div className="my-leagues-card-info">
                  <h3 className="my-leagues-card-name">{league.name}</h3>
                  <span className="my-leagues-card-abbr">{league.abbr}</span>
                </div>
              </div>
              <div className="my-leagues-card-arrow">
                <i className="bi bi-chevron-right" />
              </div>
            </div>
          ))}
        </div>
      )}
    </Container>
  );
}
